// extracted by mini-css-extract-plugin
export default {"tab":"tab_tab__D-vBg","tab_content":"tab_tab_content__Ep65Q"};